import { KeyRound, LogOut, ShieldCheck } from 'lucide-react';
import type { AccessRestriction } from '@nexops/shared';
import { useI18n } from '@/i18n/I18nProvider';
import { useSignOut } from '@/features/auth/useSession';
import { Button, Card } from '@/shared/ui';
import { refreshSession } from './account.api';
import { ChangePasswordForm } from './ChangePasswordForm';
import { TwoFactorPanel } from './TwoFactorPanel';

/**
 * Shown instead of the application while the session is restricted: a temporary password must be replaced,
 * or a required second factor set up. The server refuses every other call until then.
 */
export function AccessGate({ restriction }: { restriction: AccessRestriction }) {
  const { t } = useI18n();
  const signOut = useSignOut();
  const password = restriction === 'PASSWORD_CHANGE';
  return (
    <div className="flex min-h-dvh items-center justify-center bg-background p-4">
      <Card className="w-full max-w-md rounded-3xl p-6 shadow-pop">
        <div className="mb-4 flex items-start gap-3">
          <span className="brand-gradient flex size-11 shrink-0 items-center justify-center rounded-2xl text-white [&_svg]:size-5">{password ? <KeyRound /> : <ShieldCheck />}</span>
          <div>
            <h1 className="text-lg font-extrabold leading-tight">{password ? t('acct.gate.passwordTitle') : t('acct.gate.twoFactorTitle')}</h1>
            <p className="mt-1 text-[13px] text-muted-foreground">{password ? t('acct.gate.passwordBody') : t('acct.gate.twoFactorBody')}</p>
          </div>
        </div>
        {password ? <ChangePasswordForm currentLabel={t('acct.gate.currentLabel')} onDone={() => void refreshSession()} /> : <TwoFactorPanel onEnabled={() => void refreshSession()} />}
        <Button variant="ghost" size="sm" className="mt-4" onClick={() => void signOut('logout')}>
          <LogOut />
          {t('common.logout')}
        </Button>
      </Card>
    </div>
  );
}
